module.exports = __webpack_public_path__ + "img/ic_salesforce.bcb008f5.png";